// DashboardLayout.js
import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import NotificationPanel from '../components/NotificationPanel';

import { Box, Flex, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, Button, useMediaQuery, IconButton, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, Text } from "@chakra-ui/react";
import { IoMdMenu, IoMdHome, IoMdChatboxes, IoMdCreate, IoMdSearch, IoMdNotificationsOutline, IoMdCard } from "react-icons/io";
import { useTranslation } from "react-i18next";


const DashboardLayout = ({ children }) => {
  const { t } = useTranslation();

  const [isLargerThanMd] = useMediaQuery("(min-width: 768px)");
  const { isOpen: isSidebarOpen, onOpen: openSidebar, onClose: closeSidebar } = useDisclosure(); // Renamed for clarity
  const sidebarWidth = isLargerThanMd ? "250px" : "0px";
  const { isOpen: isNotificationPanelOpen, onOpen: openNotificationPanel, onClose: closeNotificationPanel } = useDisclosure(); // For Popover control


  // Sidebar routes with translated names
  const sidebarRoutes = [
    { path: "/personal/dashboard", name: t("dashboardlayout.dashboard"), icon: IoMdHome },
    { path: "/personal/post-listing", name: t("dashboardlayout.post_an_offer"), icon: IoMdCreate },
    { path: "/personal/listings", name: t("dashboardlayout.explore_listings"), icon: IoMdSearch },
    { path: "/personal/chat-list", name: t("dashboardlayout.view_chats"), icon: IoMdChatboxes },
    { path: "/personal/billing", name: t("dashboardlayout.billing"), icon: IoMdCard },
  ];

  return (
    <Flex direction="column" height="100vh">
      <Flex flex="1" overflow="hidden">
        {/* Mobile Menu Button */}
        {!isLargerThanMd && (
          <Button onClick={openSidebar} position="fixed" top={4} left={4} zIndex="110" colorScheme="blue">
            <IoMdMenu />
          </Button>
        )}

        {/* Sidebar */}
        {isLargerThanMd ? (
          <Sidebar routes={sidebarRoutes} isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        ) : (
          <Drawer isOpen={isSidebarOpen} placement="left" onClose={closeSidebar}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <Sidebar routes={sidebarRoutes} isOpen={true} onClose={closeSidebar} />
            </DrawerContent>
          </Drawer>
        )}

        {/* Main Content Area */}
        <Box
          flex="1"
          ml={isLargerThanMd ? sidebarWidth : 0}
          pt={20}
          overflowY="auto"
          bg="gray.100"
          p={6}
          transition="margin-left 0.3s ease-in-out"
        >
          {children}
        </Box>

        {/* Notification Icon/Popover */}
        <Popover
          isOpen={isNotificationPanelOpen}
          onOpen={openNotificationPanel} // Call this when the icon is clicked
          onClose={closeNotificationPanel}
          // Add these props for better mobile behavior:
          closeOnBlur={false} // Prevent closing when clicking outside (especially on mobile)
          autoFocus={false}  // Prevent auto-focus on the Popover, which can cause issues
          placement="bottom-end" // Or "bottom" if you prefer
        >
          <PopoverTrigger>
            <IconButton
              icon={<IoMdNotificationsOutline />}
              aria-label={t("dashboardlayout.notifications")}
              position="fixed"
              top={4}
              right={4}
              zIndex="110"
              onClick={openNotificationPanel} // Open the Popover
              colorScheme="blue"
            />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverCloseButton />
            <NotificationPanel />
          </PopoverContent>
        </Popover>

      </Flex>
      {/* <Footer sidebarWidth={isLargerThanMd ? sidebarWidth : "0px"} /> */}
    </Flex>
  );
};

export default DashboardLayout;
